import React, {Component} from 'react'
import {connect} from 'react-redux'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableFooter from '@material-ui/core/TableFooter'
import Paper from '@material-ui/core/Paper'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import ClearIcon from '@material-ui/icons/Clear'
import ModeEditIcon from '@material-ui/icons/ModeEdit'
import MenuItem from '@material-ui/core/MenuItem';
import _ from 'lodash'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { reduxForm} from 'redux-form'
import qs from 'querystring';
import Pagination from '../../../../../uis/pagination'
import NoData from '../../../../../uis/noData'
import * as actions from '../reducers/list'
import EnhancedFilterField from '../../../../../uis/enhancedFilterFiled';
import Text from '../../../../../uis/form/text';
import Textarea from '../../../../../uis/form/textarea';
import Number from '../../../../../uis/form/number';
import Select from '../../../../../uis/form/select'
import * as http from '../../../../../util/http'
import dateFormat from '../../../../../util/dateFormat'

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    textField: {
        width: 300,
        margin: theme.spacing.unit
    },
    dislogActions: {
        display: 'flex',
        justifyContent: 'space-around',
        margin: theme.spacing.unit * 3
    },
    contentCell: {
        maxWidth: 100,
        whiteSpace: 'noWrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    },
    group: {
        margin: `${theme.spacing.unit}px 0`,
        flexDirection: 'row'
    },
})

const validate = values => {
    const errors = {}
    if (!values.type) {
        errors.type = '必填'
    }
    if (!values.orderName) {
        errors.orderName = '必填'
    }
    if (values.isNeedBuyDomain === undefined) {
        errors.isNeedBuyDomain = '必填'
    }
    if (!values.buyYear) {
        errors.buyYear = '必填'
    }
    if (values.buyYear > 10) {
        errors.buyYear = '不能超过10年'
    }
    if (!values.orderMoney) {
        errors.orderMoney = '必填'
    }
    if (values.isAuto  === undefined) {
        errors.isAuto = '必填'
    }
    
    return errors
}

const asyncValidate = (values /*, dispatch */) => {
    return http.get(`/order-renew/is-exist/${values.orderName}`)
        .then(data => {
            if (!data.data) {
                // eslint-disable-next-line
                throw { orderName: '不存在' }
            }
        })
}

class AddDialog extends React.Component {
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit} = this.props
        return (<Dialog
            open={showModal.add}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent}>

                    <Select name="type" label="续费类型" placeholder="请输入续费类型" className={classes.textField} required={true} data={[{"name":"仿站订单","value": '仿站订单'},{"name":"模板建站订单","value": '自主研发订单'}]}/>

                    <Text name="orderName" label="项目名" placeholder="请输入项目名" className={classes.textField} required={true}/>
                    
                    <Select name="isNeedBuyDomain" label="是否需要续费域名" placeholder="请输入是否需要续费域名" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>

                    <Number name="buyYear" label="续费年限" placeholder="请输入续费年限" className={classes.textField} required={true} data={[]}/>

                    <Number name="orderMoney" label="续费金额" placeholder="请输入续费金额" className={classes.textField} required={true} data={[]}/>

                    <Select name="isAuto" label="是否自动" placeholder="请输入是否自动" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>

                    <Textarea name="remarks" label="备注" placeholder="请输入备注" className={classes.textField} required={false} data={[]}/>
                    
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button type="submit" variant="outlined" color="primary" disabled={pristine || submitting}>确定</Button>
                </DialogActions>
            </form>
        </Dialog>)
    }
}
class UpdateDialog extends Component {
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit} = this.props
        return (<Dialog
            open={showModal.update}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent}>
                    
                    <Select name="type" label="续费类型" placeholder="请输入续费类型" className={classes.textField} required={true} data={[{"name":"仿站订单","value": '仿站订单'},{"name":"模板建站订单","value": '自主研发订单'}]}/>

                    <Text name="orderName" label="项目名" placeholder="请输入项目名" className={classes.textField} required={true}/>

                    <Select name="isNeedBuyDomain" label="是否需要续费域名" placeholder="请输入是否需要续费域名" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>

                    <Number name="buyYear" label="续费年限" placeholder="请输入续费年限" className={classes.textField} required={true} data={[]}/>

                    <Number name="orderMoney" label="续费金额" placeholder="请输入续费金额" className={classes.textField} required={true} data={[]}/>

                    <Select name="isAuto" label="是否自动" placeholder="请输入是否自动" className={classes.textField} required={true} data={[{"name":"是","value":true},{"name":"否","value":false}]}/>

                    <Textarea name="remarks" label="备注" placeholder="请输入备注" className={classes.textField} required={false} data={[]}/>
                    {http.isRoot() && <div className={classes.doubleTextField}>
                        <Select name="status" label="状态" placeholder="请输入状态" className={classes.textField} style={{margin: 0}} data={[
                            {"name":"新增","value":"新增"},
                            {"name":"完成","value":"完成"},
                            {"name":"错误","value":"错误"}
                        ]} disabled={showModal.disabled}/>
                    </div>}
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button type="submit" variant="outlined" color="primary" disabled={pristine || submitting}>确定</Button>
                </DialogActions>
            </form>
        </Dialog>)
    }
}

class DeleteDialog extends Component {
    render() {
        const {dispatch,showModal} = this.props
        return (<Dialog
            open={showModal.delete}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <DialogContent>确定删除吗？</DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                <Button variant="outlined" color="primary" onClick={() => dispatch(actions.remove(showModal.id))}>确定</Button>
            </DialogActions>
        </Dialog>)
    }
}

const AddFormDialog = connect(
    state => {
        const params = qs.parse(window.location.search.substring(1));
        return {
            initialValues: {
                ...params,
                isNeedBuyDomain: false,
                isAuto: true,
            }
        }
    },
  )(reduxForm({
    form: 'orderRenewAddForm',
    validate,
    asyncValidate,
    asyncBlurFields: ['orderName']
})(AddDialog))

const UpdateFormDialog = connect(
    state => ({
      initialValues: state.orderRenew.detail
    }),
  )(reduxForm({
    form: 'orderRenewUpdateForm'
})(UpdateDialog))

class OrderRenew extends Component {
    componentDidMount() {
        const {dispatch, location}  = this.props
        dispatch(actions.getList())
        dispatch(actions.getStatusDetail())
        console.info(location);
        const params = new URLSearchParams(location.search);
        const opt = params.get('opt');
        if (opt === 'add') {
            dispatch({type: actions.SHOW_MODAL,key: 'add'})
        }
    }
    onPageClick = (index) => {
        const {dispatch,page} = this.props
        dispatch({
            type: actions.CHANGE_PAGE,
            page: {...page, index}
        })
        dispatch(actions.getList())
    }
    handleFiltersClick = (value) => {
        const { dispatch,filterList } = this.props
        const valueItem = filterList.find(item=>item.value === value);
        valueItem.isShow = !valueItem.isShow;
        dispatch({type: actions.CHANGE_FILTER_LIST,value: _.clone(filterList)})
    }
    cancelFiltersClick = (value) => {
        const { dispatch, query } = this.props
        this.handleFiltersClick(value);
        if (query[value]) {
            dispatch({type: actions.CHANGE_QUERY, key: value, value: null})
            dispatch(actions.getList())
        }
    }
    changeQuery = (e,name) => {
        const {dispatch} = this.props;
        dispatch({type: actions.CHANGE_QUERY,key: name,value: e.target.value})
        dispatch(actions.getList())
    }
    render() {
        const {classes, dispatch, list, page, total ,permissionMap, query, filterList, showModal, statusDeatial} = this.props
        return (
            <div>
                <Grid container spacing={8} alignItems="baseline" style={{justifyContent: 'space-between'}}>
                    <Grid item>
                        {permissionMap['续费订单_新增'] && <Button variant="outlined" color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'add'})}>新增</Button>}
                    </Grid>
                    <Grid item>
                        <TextField
                            select
                            label="选择筛选条件"
                            margin="normal"
                            style={{minWidth: 200}}
                            onChange={(event) => this.handleFiltersClick(event.target.value)}
                        >
                            {filterList.filter(item => !item.isShow).map((item, index) => {
                                return (
                                    <MenuItem
                                        key={index}
                                        value={item.value}
                                    >
                                        {item.name}
                                    </MenuItem>
                                );
                            })}
                        </TextField>
                    </Grid>
                </Grid>
                <Grid container spacing={8}>
                    {filterList.filter(item => item.isShow).map((item, index) => {
                        return (
                            <EnhancedFilterField
                                item={item}
                                value={query[item.value]}
                                key={index}
                                onHandleQuery={(e) => this.changeQuery(e, item.value)}
                                onCancel={this.cancelFiltersClick}
                            />
                        );
                    })}
                </Grid>
                <Grid container spacing={8}>
                    <FormControl component="fieldset" className={classes.formControl}>
                        <RadioGroup
                            name="status"
                            className={classes.group}
                            value={query.status}
                            onChange={(e) => this.changeQuery(e,'status')}
                        >
                            <FormControlLabel value="" control={<Radio />} label={<p>全部<span style={{color: 'red'}}>（{statusDeatial['全部'] || 0}）</span></p>} />
                            {statusDeatial['新增'] && <FormControlLabel value="新增" control={<Radio />} label={<p>新增<span style={{color: 'red'}}>（{statusDeatial['新增']}）</span></p>} />}
                            {statusDeatial['完成'] && <FormControlLabel value="完成" control={<Radio />} label={<p>完成<span style={{color: 'red'}}>（{statusDeatial['完成']}）</span></p>} />}
                            {statusDeatial['错误'] && <FormControlLabel value="错误" control={<Radio />} label={<p>错误<span style={{color: 'red'}}>（{statusDeatial['错误']}）</span></p>} />}
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Paper className={classes.root}>
                    {list.length === 0 && <NoData />}
                    {list.length > 0 && <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell>续费类型</TableCell>
                                <TableCell>项目名</TableCell>
                                <TableCell>是否需要续费域名</TableCell>
                                <TableCell>续费年限</TableCell>
                                <TableCell>续费金额</TableCell>
                                <TableCell>是否自动</TableCell>
                                <TableCell>创建人</TableCell>
                                <TableCell>来源</TableCell>
                                <TableCell>状态</TableCell>
                                {(permissionMap['续费订单_修改'] || permissionMap['续费订单_删除']) && <TableCell>操作</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.map(row => {
                                return (
                                    <TableRow key={row.id}>
                                        <TableCell>{row.type}</TableCell>
                                        <TableCell>{row.orderName}</TableCell>
                                        <TableCell>{row.isNeedBuyDomain ? '是' : '否'}</TableCell>
                                        <TableCell>{row.buyYear}</TableCell>
                                        <TableCell>{row.orderMoney}</TableCell>
                                        <TableCell>{row.isAuto ? '是' : '否'}</TableCell>
                                        <TableCell>{row.accountName}</TableCell>
                                        <TableCell>{row.referDomain}</TableCell>
                                        <TableCell>
                                            <p>订单状态: {row.status}</p>
                                            {row.status === '错误' && <p>错误原因: {row.statusMessage}</p>}
                                            <p>创建时间: {dateFormat(new Date(row.createTime))}</p>
                                            <p>更新时间: {dateFormat(new Date(row.updateTime))}</p>
                                        </TableCell>
                                        {(permissionMap['续费订单_修改'] || permissionMap['续费订单_删除']) && <TableCell>
                                            {permissionMap['续费订单_修改'] && <Tooltip title="修改">
                                                <IconButton color="primary" onClick={()=>dispatch(actions.showUpdateModal(row.id))}><ModeEditIcon /></IconButton>
                                            </Tooltip>}
                                            {permissionMap['续费订单_删除'] && <Tooltip title="删除">
                                                <IconButton color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'delete', id: row.id})}><ClearIcon /></IconButton>
                                            </Tooltip>}
                                        </TableCell>}
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                        <TableFooter>
                            <Pagination 
                                total={total}
                                {...page}
                                onPageClick={this.onPageClick}
                            />
                        </TableFooter>
                    </Table>}
                </Paper>
                {showModal.add && <AddFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.add(formData))}/>}
                {showModal.update && <UpdateFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.update(formData))} />}
                {showModal.delete && <DeleteDialog {...this.props} />}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.orderRenew,
        permissionMap: state.auth.user.permissionMap
    }
}

export default connect(mapStateToProps)(withStyles(styles)(OrderRenew))


// WEBPACK FOOTER //
// ./src/pages/home/routes/order_renew/components/list.js